import { render, staticRenderFns } from "./property-order-detail.vue?vue&type=template&id=4c13056d&scoped=true&"
import script from "./property-order-detail.vue?vue&type=script&lang=js&"
export * from "./property-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./property-order-detail.vue?vue&type=style&index=0&id=4c13056d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13056d",
  null
  
)

export default component.exports